<template>
  <div class="guest">
    <div class="guestTop">
      <div class="guestTopLeft">
        <div class="guestTopLeftTitle">重磅嘉宾</div>
        <div class="guestTopLeftEn">IMPORTANT GUESTS</div>
      </div>
      <div class="guestTopRight"></div>
    </div>
    <!-- <van-swipe :autoplay="3000" class="swipe">
      <van-swipe-item v-for="(item, index) in arr" :key="index">
        <div class="guestBox">
          <div v-for="(node, index) in item" :key="index" class="guestBoxItem">
            <img :src="node.avatar" alt="" class="guestBoxItemAvatar" />
            <div class="guestBoxItemName">{{ node.name }}</div>
            <div class="guestBoxItemJob guestBoxItemText">{{ node.job }}</div>
            <div class="guestBoxItemTitle guestBoxItemText">{{ node.title }}</div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe> -->
    <van-swipe :autoplay="3000" class="swipe">
      <van-swipe-item v-for="(item, index) in arr" :key="index">
        <div class="guestBox">
          <div v-for="(node, index) in item" :key="index" class="guestBoxItem">
            <img :src="node.avatar" alt="" class="guestBoxItemAvatar" />
            <div class="guestBoxItemName">{{ node.name }}</div>
            <div class="guestBoxItemTitle guestBoxItemText van-multi-ellipsis--l3">{{ node.title.join(',') }}</div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getKeyGuest } from '@/api/2024/index'

// const arr = ref([
//   [
//     {
//       avatar: 'https://p4.ssl.qhimg.com/t110b9a9301aaece71536b06f4f.png',
//       name: '邬贺铨',
//       job: 'ISC名誉主席',
//       title: '中国工程院院士'
//     },
//     {
//       avatar: 'https://p0.ssl.qhimg.com/t110b9a930125d5652372593e8f.png',
//       name: '王秀军',
//       job: 'ISC名誉主席',
//       title: '中国网络空间安全协会理事长'
//     }
//   ],
//   [
//     {
//       avatar: 'https://p4.ssl.qhimg.com/t110b9a9301aaece71536b06f4f.png',
//       name: '王雷',
//       title: 'ISC名誉主席中国工程院院士'
//     },
//     {
//       avatar: 'https://p0.ssl.qhimg.com/t110b9a930125d5652372593e8f.png',
//       name: '李晓华',
//       title: 'ISC名誉主席中国网络空间安全协会理事长'
//     }
//   ]
// ])

const arr = ref([])

onBeforeMount(async () => {
  await fetch()
})

const fetch = () => {
  getKeyGuest('ISC 荣誉主席,重磅嘉宾').then((res) => {
    let guests = res.data.data
    arr.value = chunkArray(guests, 2)
  })
}

const chunkArray = (array, chunkSize) => {
  const result = []
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize))
  }
  return result
}
</script>

<style lang="scss" scoped>
.guest {
  opacity: 1;
  background: #f3f3f3;
  padding: 32px 16px 40px;
  &Top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    &Left {
      &Title {
        font-family: Source Han Sans;
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-9 */
        color: #242933;
        margin-bottom: 2px;
      }
      &En {
        font-family: Source Han Sans;
        font-size: 12px;
        font-weight: normal;
        line-height: 18px;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-7 */
        color: #8a9099;
      }
    }
    &Right {
      font-family: Source Han Sans;
      font-size: 12px;
      font-weight: normal;
      line-height: 18px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-7 */
      color: #8a9099;
    }
  }
  &Box {
    display: flex;
    justify-content: space-between;
    &Item {
      width: 156px;
      &Avatar {
        width: 150px;
        border-radius: 50%;
      }
      &Name {
        font-family: Source Han Sans;
        font-size: 14px;
        font-weight: 500;
        line-height: 22px;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        /* Gray 中性/gray-9 */
        color: #242933;
        margin: 8px 0;
        text-align: center;
      }
      &Text {
        font-family: Source Han Sans;
        font-size: 12px;
        font-weight: normal;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0px;
        font-variation-settings: 'opsz' auto;
        color: rgba(61, 61, 61, 0.698);
        text-align: center;
      }
    }
  }
  :deep(.van-swipe__indicators) {
    position: relative;
    margin-top: 35px;
    justify-content: center;
  }
  .swipe {
    --van-swipe-indicator-active-background: #525966;
    --van-swipe-indicator-inactive-background: #dfe1e6;
    --van-swipe-indicator-size: 8px;
  }
}
</style>
